export const isExcelDoc = (doc) =>
  !doc.isVerveDesignMedia && !doc.isRelatedToCatalog && (
    doc.fileType?.includes('spreadsheetml') ||
    doc.fileType?.includes('excel') ||
    doc.fileName?.endsWith('.xlsx') ||
    doc.fileName?.endsWith('.xls') ||
    doc.fileName?.endsWith('.csv')
  );

export const isCatalogDoc = (doc) => doc.isRelatedToCatalog;

export const isWordDoc = (doc) =>
  !doc.isRelatedToCatalog && (
    doc.fileType?.includes('wordprocessingml') ||
    doc.fileType?.includes('word') ||
    doc.fileName?.endsWith('.docx') ||
    doc.fileName?.endsWith('.doc')
  );

export const isPdfDoc = (doc) =>
  !doc.isRelatedToCatalog && (doc.fileType?.includes('pdf') || doc.fileName?.endsWith('.pdf'));

export const isDrawingDoc = (doc) =>
  !doc.isRelatedToCatalog && (
    doc.isVerveDesignMedia ||
    doc.fileName?.endsWith('.dwg') ||
    doc.fileName?.endsWith('.dxf') ||
    doc.fileName?.endsWith('.png') ||
    doc.fileName?.endsWith('.jpg') ||
    doc.fileName?.endsWith('.jpeg') ||
    doc.fileType?.includes('image')
  );

export const getFileIconType = (doc) => {
  if (isCatalogDoc(doc)) return 'other';
  if (isPdfDoc(doc)) return 'pdf';
  if (isExcelDoc(doc)) return 'excel';
  if (isWordDoc(doc)) return 'word';
  if (isDrawingDoc(doc)) return 'drawing';
  return 'other';
};

export const groupDocuments = (docs = []) => ({
  catalog: docs.filter(isCatalogDoc),
  word: docs.filter(isWordDoc),
  excel: docs.filter(isExcelDoc),
  pdf: docs.filter(isPdfDoc),
  drawings: docs.filter(isDrawingDoc),
  other: docs.filter((doc) => !isCatalogDoc(doc) && !isWordDoc(doc) && !isExcelDoc(doc) && !isPdfDoc(doc) && !isDrawingDoc(doc)),
});

export const filterDocuments = (docs, search = '', formatFilter = 'all', filters = {}) => {
  const q = search.trim().toLowerCase();
  let filtered = docs.filter(
    (doc) =>
      !q ||
      doc.title?.toLowerCase().includes(q) ||
      doc.fileName?.toLowerCase().includes(q) ||
      doc.category?.toLowerCase().includes(q) ||
      doc.notes?.toLowerCase().includes(q)
  );

  if (formatFilter === 'catalog') filtered = filtered.filter(isCatalogDoc);
  else if (formatFilter === 'excel') filtered = filtered.filter(isExcelDoc);
  else if (formatFilter === 'word') filtered = filtered.filter(isWordDoc);
  else if (formatFilter === 'pdf') filtered = filtered.filter(isPdfDoc);
  else if (formatFilter === 'drawings') filtered = filtered.filter(isDrawingDoc);
//updated Halimunnisa 09-06-2026
  // Apply date filters
  if (filters.date && filters.date !== 'all') {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const docDate = (doc) => new Date(doc.updatedAt || doc.createdAt);
    
    if (filters.date === 'today') {
      filtered = filtered.filter(doc => docDate(doc) >= today);
    } else if (filters.date === 'week') {
      const weekAgo = new Date(today);
      weekAgo.setDate(weekAgo.getDate() - 7);
      filtered = filtered.filter(doc => docDate(doc) >= weekAgo);
    } else if (filters.date === 'month') {
      const monthAgo = new Date(today);
      monthAgo.setMonth(monthAgo.getMonth() - 1);
      filtered = filtered.filter(doc => docDate(doc) >= monthAgo);
    } else if (filters.date === 'year') {
      const yearAgo = new Date(today);
      yearAgo.setFullYear(yearAgo.getFullYear() - 1);
      filtered = filtered.filter(doc => docDate(doc) >= yearAgo);
    }
  } else if (filters.fromDate || filters.toDate) {
    const docDate = (doc) => new Date(doc.updatedAt || doc.createdAt);
    filtered = filtered.filter(doc => {
      const d = docDate(doc);
      if (filters.fromDate) {
        const from = new Date(filters.fromDate);
        from.setHours(0, 0, 0, 0);
        if (d < from) return false;
      }
      if (filters.toDate) {
        const to = new Date(filters.toDate);
        to.setHours(23, 59, 59, 999);
        if (d > to) return false;
      }
      return true;
    });
  }

  return filtered;
};

export const hasEditAccess = (doc, user) => {
  if (!user || !doc) return false;
  if (user.role === 'owner' || user.role === 'admin') return true;
  const uploaderId = typeof doc.uploadedBy === 'string' ? doc.uploadedBy : doc.uploadedBy?._id;
  if (uploaderId === user._id) return true;
  return doc.permissions?.some(
    (p) =>
      (typeof p.user === 'string' ? p.user === user._id : p.user?._id === user._id) && p.canEdit
  );
};

export const formatDocDate = (dateStr) => {
  if (!dateStr) return '—';
  return new Date(dateStr).toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};
